"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag3dEngine = void 0;
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
const viewer_shared_global_access_objects_1 = require("@shapediver/viewer.shared.global-access-objects");
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
class Tag3dEngine {
    constructor() {
        // #region Properties (3)
        this._globalAccessObjects = viewer_shared_global_access_objects_1.GlobalAccessObjects.instance;
        this._stateEngine = viewer_shared_services_1.StateEngine.instance;
        // #endregion Public Methods (1)
    }
    // #endregion Properties (3)
    // #region Public Static Getters And Setters (1)
    static get instance() {
        return this._instance || (this._instance = new this());
    }
    // #endregion Public Static Getters And Setters (1)
    // #region Public Methods (1)
    /**
     * Load the tag3d content into a scene graph node.
     *
     * @param content the tag3d content
     * @returns the scene graph node
     */
    loadContent(content) {
        return __awaiter(this, void 0, void 0, function* () {
            const node = new viewer_shared_node_tree_1.TreeNode('tag3d');
            if (!content)
                throw new viewer_shared_services_1.ShapeDiverViewerDataProcessingError('Tag3dEngine.loadContent: Invalid content was provided to tag3d engine.');
            if (content.data && Array.isArray(content.data)) {
                if (this._globalAccessObjects.loadTag3D) {
                    for (let i = 0; i < content.data.length; i++) {
                        const tag3dInfo = content.data[i];
                        const child = this._globalAccessObjects.loadTag3D(tag3dInfo);
                        if (child)
                            node.addChild(child);
                    }
                }
                else {
                    const customData = new viewer_shared_types_1.CustomData({});
                    for (let i = 0; i < content.data.length; i++) {
                        const tag3dInfo = content.data[i];
                        customData.data['tag3d_' + tag3dInfo.version] = tag3dInfo;
                    }
                    node.addData(customData);
                }
            }
            else {
                throw new viewer_shared_services_1.ShapeDiverViewerDataProcessingError('Tag3dEngine.loadContent: No tag3d data was provided to tag3d engine.');
            }
            return node;
        });
    }
}
exports.Tag3dEngine = Tag3dEngine;
//# sourceMappingURL=Tag3dEngine.js.map